/**
 * Shared styling for the square icon buttons in the top-right of the HUD
 * (wallet, codex menu). Deliberately mirrors the lives/gold/wave chips on the
 * left - same translucent black plate, same radius, same 28px height - so both
 * corners read as one HUD rather than two different UIs.
 *
 * The plate matches the chips visually, and the `after` pseudo-element widens
 * the touch target beyond it so the smaller button is still comfortable to tap
 * on a phone.
 */
export const HUD_ICON_BUTTON_CLASS =
  "relative h-7 w-7 bg-black bg-opacity-60 text-white rounded-lg flex items-center justify-center " +
  "transition hover:bg-opacity-80 active:scale-95 " +
  "after:absolute after:-inset-2 after:content-['']"
